/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { COUPON_DIS_REPORT } from "../graphql/getDiscountReport.query";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IDiscountCouponReportMethods extends IPluginMethodMap {
  getDiscountCouponReport(args: any): Promise<any>;
}

export class DiscountCouponReportService implements IAgentPlugin {
  readonly methods: IDiscountCouponReportMethods;
  private pollingTime = 10000;

  constructor() {
    this.methods = {
      getDiscountCouponReport: this.getDiscountCouponReport.bind(this),
    };
  }

  async getDiscountCouponReport(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    let filters = {};

    try {
      if (client) {
        if (args?.couponCode) {
          filters = {
            ...filters,
            couponCode: {
              eq: args?.couponCode,
            },
          };
        }

        const costumeDataRes = await client.query({
          query: COUPON_DIS_REPORT,
          variables: {
            filters: filters,
          },
          fetchPolicy: "network-only",
        });

        if (
          costumeDataRes?.data?.getDiscountCodeListReport?.csvUrl &&
          is.existy(costumeDataRes?.data?.getDiscountCodeListReport?.csvUrl)
        ) {
          return {
            csv: costumeDataRes?.data?.getDiscountCodeListReport?.csvUrl
          }
        } else {
          throw new Error("Some unexpected error occurred");
        }
      }
    } catch (err: any) {
      console.error("getDiscountCouponReport error ", err);

      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

}
